/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "reasons-for-delivery-failure-management",
	data() {
		return {
			reasonsForDeliveryFailure: [],
			reasonsForDeliveryFailureHeadings: [
				{
					text: "#",
					field: "failedReasonId"
				},
				{
					text: "Reason",
					field: "reason"
				},
				{
					text: "Is Active",
					field: "isActive"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			drivers: [],
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive"
			},
			reasonForDeliveryFailureAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditReasonForDeliveryFailureModal",
				heading: "Add Reason For Delivery Failure",
				reasonForDeliveryFailure:{
					reasonForDeliveryFailureId: null,
					description: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					isActive: true
				}
			},
			reasonForDeliveryFailureMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveReasonForDeliveryFailureModal",
				heading: "Mark Reason For Delivery Failure As Active/Inactive",
				isActive: null
			},
			newAddOrUpdateConcluded: false,
			filterStateChanged: false,
			filter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getReasonsForDeliveryFailure() {
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
			};
			// let fieldsToFilterBy = [
			// 	{
			// 		value: this.filter.customerSearchQuery,
			// 		key: "reason"
			// 	}
			// ];
			// let activeOnly = castingUtility.toBoolean(this.filter.activeOrInactiveItems);
			orderService.getFailedReasons(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.reasonsForDeliveryFailure = successResponse.data.result;
						for(let i = 0; i < this.reasonsForDeliveryFailure.length; i++){
							this.reasonsForDeliveryFailure[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit,
									elementId: "btnEditReasonForDeliveryFailure"
								},
								{
									name: this.reasonsForDeliveryFailure[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive,
									elementId: "btnMarkReasonForDeliveryFailureAsActiveInactive"
								}
							];
						}
						this.reasonsForDeliveryFailure = dataTableHelper.castFieldValues(this.reasonsForDeliveryFailure);
						this.filterStateChanged = false;
						this.newAddOrUpdateConcluded = false;
						permissionsHelper.setControlsBasedOnPermissions();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.getReasonsForDeliveryFailure();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onAddReasonForDeliveryFailureClick(){
			this.reasonForDeliveryFailureAddEditFormModal.heading = "Add Reason For Delivery Failure";
			this.clearReasonForDeliveryFailureReasonModel();
			this.reasonForDeliveryFailureAddEditFormModal.showModal = true;
		},
		onReasonForDeliveryFailureActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.reasonForDeliveryFailureAddEditFormModal.showModal = true;
					this.reasonForDeliveryFailureAddEditFormModal.heading = "Edit Reason For Delivery Failure";
					this.reasonForDeliveryFailureAddEditFormModal.reasonForDeliveryFailure.reasonForDeliveryFailureId = actionAndData.data.failedReasonId;
					this.reasonForDeliveryFailureAddEditFormModal.reasonForDeliveryFailure.description.value = actionAndData.data.reason;
					this.reasonForDeliveryFailureAddEditFormModal.reasonForDeliveryFailure.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					break;
				case this.actionKeys.markAsActiveInactive:
					this.reasonForDeliveryFailureMarkAsActiveInactiveModal.showModal = true;
					this.reasonForDeliveryFailureMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.reasonForDeliveryFailureMarkAsActiveInactiveModal.heading = "Mark Reason For Delivery Failure As " + (this.reasonForDeliveryFailureMarkAsActiveInactiveModal.isActive ? "Inactive" : "Active") + " - " + actionAndData.data.reason;
					this.reasonForDeliveryFailureMarkAsActiveInactiveModal.reasonForDeliveryFailureId = actionAndData.data.failedReasonId;
					break;
			}
		},
		onMarkReasonForDeliveryFailureActiveInactiveSelected(isActive){
			this.reasonForDeliveryFailureMarkAsActiveInactiveModal.isActive = isActive;
			console.log("reasonForDeliveryFailureMarkAsActiveInactiveModal.isActive", this.reasonForDeliveryFailureMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.reasonForDeliveryFailureMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				failedReasonId: this.reasonForDeliveryFailureMarkAsActiveInactiveModal.reasonForDeliveryFailureId,
				isActive: markAsActive
			};
			orderService.markFailedReasonAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						// this.newAddOrUpdateConcluded = true;
						// this.filter = {
						// 	customerSearchQuery: null,
						// 	activeOrInactiveItems: castingUtility.booleanToNumber(markAsActive)
						// };
						// let key = localStorageCacheHelper.localStorageKey.zonesKey;
						// if(markAsActive){
						// 	key = localStorageCacheHelper.localStorageKey.zonesInactiveKey
						// }
						// localStorageCacheHelper.removeItemFromCache("failedReasonId", this.reasonForDeliveryFailureMarkAsActiveInactiveModal.reasonForDeliveryFailureId, key);
						this.reasonForDeliveryFailureMarkAsActiveInactiveModal.showModal = false;
						this.reasonForDeliveryFailureMarkAsActiveInactiveModal.isActive = true;
						this.reasonForDeliveryFailureMarkAsActiveInactiveModal.reasonForDeliveryFailureId = null;
						this.getReasonsForDeliveryFailure();
					}
					this.reasonForDeliveryFailureMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.reasonForDeliveryFailureMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onAddOrEditReasonForDeliveryFailureModalCloseClick(){
			this.reasonForDeliveryFailureAddEditFormModal.showModal = false;
			this.clearReasonForDeliveryFailureReasonModel();
		},
		onAddOrEditReasonForDeliveryFailureSaveClick(){
			// TODO: save driver
			this.reasonForDeliveryFailureAddEditFormModal.isSaving = true;
			let request = {
				failedReasonId: this.reasonForDeliveryFailureAddEditFormModal.reasonForDeliveryFailure.reasonForDeliveryFailureId === null ? 0 : this.reasonForDeliveryFailureAddEditFormModal.reasonForDeliveryFailure.reasonForDeliveryFailureId,
				reason: this.reasonForDeliveryFailureAddEditFormModal.reasonForDeliveryFailure.description.value,
				isActive: this.reasonForDeliveryFailureAddEditFormModal.reasonForDeliveryFailure.isActive
			};
			orderService.addOrUpdateFailedReason(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.failedReasonValidationResponse.valuesAreValid){
							// this.newAddOrUpdateConcluded = true;
							// this.filter = {
							// 	customerSearchQuery: null,
							// 	activeOrInactiveItems: castingUtility.booleanToNumber(this.zoneAddEditFormModal.zone.isActive)
							// };
							this.getReasonsForDeliveryFailure();
							this.reasonForDeliveryFailureAddEditFormModal.showModal = false;
							this.clearReasonForDeliveryFailureReasonModel();
						}
						else{
							this.reasonForDeliveryFailureAddEditFormModal.reasonForDeliveryFailure.description.hasError = successResponse.data.failedReasonValidationResponse.reasonValidationResponse.hasError;
							this.reasonForDeliveryFailureAddEditFormModal.reasonForDeliveryFailure.description.errorMessage = successResponse.data.failedReasonValidationResponse.reasonValidationResponse.message;
						}
					}
					this.reasonForDeliveryFailureAddEditFormModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.reasonForDeliveryFailureAddEditFormModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		clearReasonForDeliveryFailureReasonModel(){
			this.reasonForDeliveryFailureAddEditFormModal.reasonForDeliveryFailure = {
				reasonForDeliveryFailureId: null,
				description: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				isActive: true
			};
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Reasons For Delivery Failure Management");
			var breadcrumbs = [];
			var breadcrumbSystem = {
				url: null,
				displayText: "System"
			};
			var reasonsForDeliveryFailureManagementBreadcrumb = {
				url: this.$route.path,
				displayText: "Reasons For Delivery Failure Management"
			};
			breadcrumbs.push(breadcrumbSystem);
			breadcrumbs.push(reasonsForDeliveryFailureManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getReasonsForDeliveryFailure();
	}
};